export default {
    //必须填写数字
    checkNumber:(rule, value, callback)=>{
        if(!value){
            return callback()
        }
        if(/^[0-9]+$/.test(value)){
            return callback()
        }else{
            return callback(new Error('只能填写数字'))
        }
    },
    //手机号码
    checkPhone:(rule, value, callback)=>{
        let data=(""+value).split('');
        if(!value){
            return callback()
        }
        if(data[0]==='1' && data.length===11){
            return callback()
        }else{
            return callback(new Error('请填写正确的手机号码'))
        }
    },
    //邮箱验证
    checkEmail: function(rule, value, callback) {
        var regEmail =  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(!value){
            return callback()
        }else if (regEmail.test(value)) {
            return callback()
        }else{
            return callback(new Error('请填写正确的邮箱地址'))
        }
    },
    //密码规则
    passRule:function(rule, value, callback){
        if(!value){
            return callback();
        }
        var reg=new RegExp('^(?=.*[0-9].*)(?=.*[a-zA-z].*).{6,12}$');//大写小写数字6-12
        if(!reg.test(value)){
            return callback(new Error('密码必须是数字和字母组成的6-12位字符'));
        }else{
            return callback()
        }
    },
    //ip验证
    checkIp:function (rule, value, callback) {
        if(!value){
            return callback();
        }
        var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if(!reg.test(value)){
            return callback(new Error('请填写正确的IP地址'));
        }else{
            return callback()
        }
    },
    //域名后缀验证
    checkDomain:function (rule, value, callback) {
        if(!value){
            return callback();
        }
        let data=value.split(".");
        if(data.length<=1){
            return callback(new Error('请填写正确的域名'));
        }else{
            return callback();
        }
    },
    //身份证
    id:function (rule, value, callback) {
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value) === false) {
            return callback(new Error('请填写正确的身份证号码'));
        }else{
            return callback();
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/rules.js